import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import { useState } from 'react';

export default function useActiveClaims() {
  const currentUser = useUser();
  const [timestamp] = useState(new Date().toISOString());

  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          userId: currentUser.id,
          response: 'Connect',
          offer: {
            $where: {
              $and: [
                {
                  completed: false
                },
                {
                  cancelled: false
                }
              ]
            }
          },
          $or: [
            {
              offer: {
                $where: {
                  $and: [
                    {
                      specificDate: 'Yes'
                    },
                    {
                      date: {
                        $gte: timestamp
                      }
                    }
                  ]
                }
              }
            },
            {
              offer: {
                $where: {
                  $and: [
                    {
                      specificDate: 'No'
                    },
                    {
                      endDate: {
                        $gte: timestamp
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });
}
